/**
 * Haversine distance between two points in degrees.
 * Returns distance in meters.
 */
export function haversineDistanceMeters(
  lat1Deg: number,
  lon1Deg: number,
  lat2Deg: number,
  lon2Deg: number,
): number {
  const R = 6371000;
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2Deg - lat1Deg);
  const dLon = toRad(lon2Deg - lon1Deg);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1Deg)) *
      Math.cos(toRad(lat2Deg)) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
